import { useParams, Link } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  Button,
  MenuItem,
  Box,
  Grid,
  Typography,
  // useMediaQuery,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import { useUserProvider } from "../context/UserProvider";

const HeaderDashboard = ({ role }) => {
  const { user } = useUserProvider();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.only("xs"));
  return (
    <Box>
      <Grid container justifyContent="space-between">
        <Grid
          item
          sx={{
            alignItems: "center",
            display: "flex",
            overflow: "hidden",
          }}
        >
          {role === "admin" || role === "editor" ? (
            <div>
              <Typography
                variant="h5"
                sx={{
                  mt: {
                    xs: 1,
                    sm: 0,
                    md: 0,
                    lg: 0,
                  },
                }}
              >
                <span style={{ color: "#3399FF" }}>Latest</span> Sites
              </Typography>
              {/* {role} */}
            </div>
          ) : (
            <div>
              <Typography
                variant="h5"
                sx={{
                  mt: {
                    xs: 1,
                    sm: 0,
                    md: 0,
                    lg: 0,
                  },
                }}
              >
                <span style={{ color: "#3399FF" }}>Latest</span> Sites
              </Typography>
            </div>
          )}
        </Grid>
        <Grid item sx={{ m: -1 }}>
          {role != "admin" || role != "editor" ? (
            // <Link to="/login" style={{ textDecoration: "none" }}>
            //   <Button
            //     component="a"
            //     sx={{
            //       m: 1,
            //       mt: {
            //         xs: 3,
            //         sm: 2,
            //         md: 2,
            //         lg: 2,
            //       },
            //     }}
            //     variant="outlined"
            //     size="small"
            //   >
            //     {isSmallScreen
            //       ? "Only editors can add a new site"
            //       : "Only editors can add a new site"}
            //   </Button>
            // </Link>
            ""
          ) : (
            <Link to="/addnewsite" style={{ textDecoration: "none" }}>
              <Button
                component="a"
                className={isSmallScreen ? "addButton xsButton" : "addButton"}
                endIcon={<AddIcon fontSize="small" />}
                sx={{
                  // mt: 1,
                  mr: 1,
                  mt: {
                    xs: 2,
                    sm: 2,
                    md: 2,
                    lg: 2,
                  },
                }}
                variant="contained"
                size="small"
              >
                ADD
              </Button>
            </Link>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default HeaderDashboard;
